import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";


export default function UseguideDetail({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [memberinfos, setmemberinfos] = useState(''); 
    const [rows, setrows] = useState({}); 

    // useEffect(() => {
    //     getMemberinfo(setmemberinfos);
    // }, []);
   
    useEffect(() => { 
        listopen();
    }, [location]);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            idx: location?.state?.vidx
        }
        APIS.postData('/v1/guide/get', sender).then(({ data }) => {
            if(data){
                setrows(data?.row);
            }
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });           
    }
    return(
        <Layout header={false} actives={''}>
            <div className='customercenter'>
                <div className='customercenterPage allround'>
                    <div className='backbuttonarea'>
                        <div>
                            <button onClick={() => { navigate('/Useguidelist'); }}>
                                <img src={`./images/icons/back.svg`} /> 
                            </button>
                            <span className='fontsize16 bolds'>이용가이드</span>
                        </div>
                    </div>             
                    <div className='detailTitles'>
                        <div className='fontsize20 bolds'>{rows?.title}</div>
                        <div className='color666'>{moment(rows?.create_dt).format('YYYY.MM.DD HH:mm')}</div>
                    </div>          
                    <div className='detail_line'></div>
                    
                    <div className='detailcontents toastui-editor-contents' dangerouslySetInnerHTML={{__html: rows?.desc}} />
                </div>
                <div
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                    className='margint20'
                >
                    <Button
                        onPress={() => {
                            navigate('/Useguidelist');
                        }}              
                        styles={{ width: 200 }}      
                        buttonTxt={'목록'}
                    />
                </div>
            </div>
        </Layout>
    )
}

